import { ContentCardProps } from 'app/components/content/ContentCard'
import usePagination from 'app/hooks/use-pagination'
import { CollectionType } from 'app/queries/collections/collection-fragment'
import {
  typeToVariable,
  createAllContentListQuery,
  contentListQueryToContentList,
  PaginationWithFeatured,
} from 'app/queries/content/content-list'
import { useStores } from 'app/store'
import { useEffect, useMemo } from 'react'

const limit = 12
const searchQuery = createAllContentListQuery()

const paginationOptions = {
  limit,
  formatFn: contentListQueryToContentList,
}

export default function useLatest(
  type: CollectionType,
  id: string = '',
  limit: number = 2,
  contentTier = '',
) {
  const { lastCollectionStore } = useStores()

  useEffect(() => {
    if (!id && lastCollectionStore) {
      return lastCollectionStore.reset()
    }
  }, [id, lastCollectionStore])

  const searchVariables = useMemo(() => {
    const vars = typeToVariable(type, id)

    return {
      sort: '-publishedAt',
      featuredLimit: limit,
      ...vars,
      ...(contentTier && { contentTier }),
    }
  }, [type, id, contentTier])

  return usePagination<ContentCardProps, PaginationWithFeatured>(
    searchQuery,
    searchVariables,
    paginationOptions
  )
}
